module.exports = __webpack_public_path__ + "static/media/multiselect.bcb08d8a.png";